import { Data } from 'effect';

import { ErrorTag } from './index';
import type { GtmEvent } from '@vs-shop/schemas/gtm/all';

export class GtmSendError extends Data.TaggedError(ErrorTag.GtmSendError)<{
  readonly event: GtmEvent;
  readonly cause?: unknown;
}> {
  override get message(): string {
    const eventName = 'event' in this.event ? this.event.event : 'page_data';
    return `GTM event send failed: ${eventName}`;
  }
}
